<template>
  <v-container fluid fill-height align-start pa-0 class="pageWrap">
    <v-sheet class="contents-container">
      <v-sheet class="w-full">
        <i-card-vertical headerTitle="대표자 확인" device="multi" contentsClass="overflow-x-hidden overflow-y-auto pr-5" :IsUseEditorBox="true">
          <template v-slot:EditorBox>
            <date-bar
              :firstDisplayDate="searchYear"
              :dateOnly="true"
              class="mx-1"
              label="조회년도"
              max-width="300px"
              year
              no-title
              style="max-width: 340px"
              @getDate="handleYearChange"
            ></date-bar>
            <v-select
              style="width: 120px"
              :menu-props="{ offsetY: true }"
              color="primary"
              item-text="minorNm"
              item-value="minorCd"
              :items="searchHalfList"
              placeholder="상반기/하반기"
              solo
              max-width="100px"
              class="editor_bg"
              v-model="searchHalfCd"
              @change="btnSearch(true)"
            />
          </template>
          <template v-slot:body>
            <div v-if="compList.length > 0">
              <v-row
                v-if="compList[0].shBudget.length > 0"
                no-gutters
                class="d-flex; justify-space-between pa-4 mb-5"
                style="width: 100%; border: 1px solid #ddd; border-radius: 10px"
              >
                <span v-if="compList[0].shBudget.length > 0" style="font-size: larger; font-weight: bold">{{ compList[0].shBudget[0].docNm }}</span>
                <v-col class="d-flex;">
                  <span class="pa-2" style="font-size: larger">확인 필요</span>
                  <v-btn x-small class="pa-0" icon @click="moveBtnClick('SHBudgetManage_new', compList[0].shBudget[0])">
                    <svg-icon style="height: 1.5rem; color: #9ba4ac" icon-class="arrow_r"></svg-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </div>
            <v-row no-gutters class="d-flex; justify-space-between">
              <div></div>

              <v-switch v-if="compList.length > 0" v-model="expandToggle" color="primary">
                <template v-slot:label>
                  <span class="ml-2 main_text--text switch-label">{{ expandToggleText }}</span>
                </template>
              </v-switch>
            </v-row>
            <div v-if="compList.length === 0">
              <h4 class="grey--text d-flex justify-center my-16">데이터가 없습니다.</h4>
            </div>
            <div v-for="(comp, compIndex) in compList" :key="`comp_${compIndex}`">
              <!-- 사업장 리스트 -->
              <expansionPanel
                ref="expansionPanel"
                :title="comp.clntNm + ' - ' + comp.compNm"
                :subTitle="String(calcSubTitleCnt(comp))"
                :subStyle="calcSubTitleCnt(comp) === 0 ? 'undefined' : 'color:red;'"
                suffix="건 확인 필요"
                :isUseExpandToggle="false"
              >
                <template v-slot:content>
                  <div v-if="calcSubTitleCnt(comp) === 0">
                    <p>{{ '확인이 필요한 문서가 없습니다.' }}</p>
                  </div>
                  <div v-else>
                    <div v-for="(type, typeIndex) in comp.dataList" :key="`type_${typeIndex}`">
                      <!-- 서명이 없는 데이터 리스트 -->
                      <expansionPanel
                        v-if="type.data.length > 0"
                        :title="type.title"
                        :subTitle="String(type.data.length)"
                        :subStyle="'color:red;'"
                        suffix="건 확인 필요"
                        :isUseExpandToggle="false"
                      >
                        <template v-slot:content>
                          <v-row no-gutters>
                            <v-card width="100%" class="doc-card py-5 px-4 mb-2" v-for="(data, dataIndex) in type.data" :key="dataIndex">
                              <div class="d-flex justify-space-between">
                                <h4>{{ data.docNm }}</h4>
                                <v-btn x-small class="pa-0" icon @click="moveBtnClick(type.route, data)">
                                  <svg-icon style="height: 1.5rem; color: #9ba4ac" icon-class="arrow_r"></svg-icon>
                                </v-btn>
                              </div>
                            </v-card>
                          </v-row>
                        </template>
                      </expansionPanel>
                    </div>
                  </div>
                </template>
              </expansionPanel>
            </div>
          </template>
          <template v-slot:drawer>
            <v-navigation-drawer v-model="procedureShow" width="75%" absolute right temporary class="feedback-area">
              <ProcedureComponent :type="'00001'" />
            </v-navigation-drawer>
          </template>
        </i-card-vertical>
      </v-sheet>
      <v-sheet class="iCardRightWrap">
        <i-card-right :useBtnList="buttonUseList" @btnSearch="btnSearch(true)"></i-card-right>
        <i-card-right>
          <template v-slot:customBtn>
            <i-icon-button color="btn_text" :text="'절차서'" :icon="'file'" @click="procedureShow = !procedureShow"></i-icon-button>
          </template>
        </i-card-right>
      </v-sheet>
    </v-sheet>
  </v-container>
</template>

<script>
// 공통 컴포넌트
import baseview from '@/views/base/baseview.vue' //20220414 LYJ base page 추가
import iCardTop from '@/components/common/iCardTop.vue'
import iCardVertical from '@/components/common/iCardVertical.vue'
import notify from 'devextreme/ui/notify'
import dateBar from '@/components/common/dateBar.vue'
import expansionPanel from '@/components/esgCommon/expansionPanel.vue'
// utils
import { getCurrentDate } from '@/utils/common.js'
import { AesEncrypt, AesDecrypt } from '@/utils/aes256'
import { getPreMonth, getTodayHalf } from '@/utils/common.js'

// API
import { getCommonCode } from '@/api/common/commonApi'
import { getCeoCheckList } from '@/api/leaderShip/ceoCheckList'
import ProcedureComponent from '@/views/procedure/components/ProcedureComponent.vue'

export default {
  mixins: [baseview],
  components: {
    // 'i-card-top': iCardTop,
    'i-card-vertical': iCardVertical,
    'date-bar': dateBar,
    expansionPanel,
    // 절차서 컴포넌트
    ProcedureComponent,
  },
  data() {
    return {
      initCompId: '',
      buttonUseList: [
        'btnSearch', // 조회
      ],
      expandToggleText: '전부 펼치기',
      expandToggle: false,
      compList: [],
      ceoCheckList: [
        // { type: 'shBudget', text: '안전보건 예산 관리', route: 'SHBudgetManage_new' },
        { type: 'workerParticipationStatus', text: '근로자 참여 현황', route: 'WorkerParticipationStatus' },
        { type: 'riskAssessment', text: '위험성평가 개설', route: 'RiskAssessmentManageDetail' },
        // { type: 'tbm', text: '안전점검회의(TBM)', route: 'TBMManageKepcoDetail' },
        { type: 'emergencyTrainingScenario', text: '비상대응 매뉴얼', route: 'EmergencyResponseTrainingDetail' },
        { type: 'emergencyTrainingResult', text: '비상대응 결과 보고서', route: 'EmergencyResponseTrainingDetail' },
        { type: 'workStoppage', text: '근로자 작업 중지', route: 'WorkStoppage' },
        { type: 'improvementMeasures', text: '개선 요구 및 결과', route: 'ImprovementMeasuresManageDetail' },
        { type: 'safetySystemEvaluate', text: '안전보건관리체계 평가', route: 'SafetySystemEvaluate' },
        { type: 'correctiveActionManage', text: '중앙, 지방단체의 개선, 시정조치', route: 'CorrectiveActionManageDetail' },
      ],
      searchYear: getPreMonth(0), // 조회조건 - 년도
      searchHalfList: [], // 조회조건 - 상반기/하반기 구분
      searchHalfCd: '', // 조회조건 - 상반기/하반기 구분 코드값
      // 절차서 컴포넌트
      procedureContent: '',
      procedureShow: false, // 절차서 보이기
    }
  },
  watch: {
    expandToggle() {
      if (this.expandToggle == false) {
        this.$refs.expansionPanel.forEach((el) => {
          el.collapseAllPanel()
        })
        this.expandToggleText = '전부 펼치기'
      } else {
        this.$refs.expansionPanel.forEach((el) => {
          el.expandAllPanel()
        })
        this.expandToggleText = '전부 접기'
      }
    },
  },
  computed: {},
  async created() {},
  beforeMount() {},
  mounted() {},
  async activated() {
    this.initCompId = this.getCompId() // 초기 페이지 진입 시 compId 세팅
    await this.initApi()
    await this.btnSearch()
    // if (this.changedCompFlag(this.initCompId)) {
    //   // 로컬 스토리지에 저장된 값을 비교하여 변경 전 / 변경 후 compId가 다르고,
    //   // 페이지 진입시 세팅해두었던 compId 와 변경 후 compId와 다를 경우
    //   this.initCompId = this.getCompId()
    //   this.btnSearch(true)
    // }
  },
  methods: {
    async initApi() {
      await getCommonCode('CM016').then((res) => {
        if (res.success) {
          this.searchHalfList = res.list
          this.searchHalfCd = res.list[getTodayHalf()].minorCd
        }
      })
      // this.btnSearch(true)
    },
    async btnSearch(notify = false) {
      this.searchYear = this.searchYear.replaceAll('-', '')
      // 조회
      let params = {
        clntId: this.getClntId(),
        writeYear: this.searchYear.substring(0, 4),
        halfDiv: this.searchHalfCd,
      }
      if (this.searchHalfCd === '00001') {
        params.searchStartDate = this.searchYear.substring(0, 4) + '0101'
        params.searchEndDate = this.searchYear.substring(0, 4) + '0630'
      } else if (this.searchHalfCd === '00002') {
        params.searchStartDate = this.searchYear.substring(0, 4) + '0701'
        params.searchEndDate = this.searchYear.substring(0, 4) + '1231'
      }
      this.openLoading()
      getCeoCheckList(params, notify)
        .then((res) => {
          if (res.success) {
            this.ceoCheckList.forEach((list) => {
              res.list.forEach((comp) => {
                let data = {
                  title: list.text,
                  route: list.route,
                  data: comp[list.type],
                }
                comp.dataList ? comp.dataList.push(data) : (comp.dataList = [data])
              })
            })
            this.compList = res.list
          }
        })
        .catch(() => {
          this.endLoading()
        })
        .finally(() => {
          this.endLoading()
        })
    },
    ///////////////////////////////////////
    /*               이벤트               */
    ///////////////////////////////////////
    handleYearChange(e) {
      this.searchYear = e.toString()
      this.btnSearch(true)
    },
    calcSubTitleCnt(comp) {
      let count = 0
      comp.dataList.forEach((data) => {
        if (!data.data) data.data.length = 0
        count = count + data.data.length
      })
      return parseInt(count)
    },
    moveBtnClick(route, data) {
      if (!data.compId) {
        // 안전보건예산 관리 경우
        data.compId = this.getCompId()
        data.compNm = this.getCompNm()
      }
      if (!data.writeDt) {
        // 시나리오 미작성일 경우
        data.writeDt = getCurrentDate().substring(0, 4)
        data.__created__ = true
      }
      data.searchHalfCd = this.searchHalfCd
      if (this.searchHalfCd === '00001') {
        data.searchStartDate = this.searchYear.substring(0, 4) + '0101'
        data.searchEndDate = this.searchYear.substring(0, 4) + '0630'
      } else if (this.searchHalfCd === '00002') {
        data.searchStartDate = this.searchYear.substring(0, 4) + '0701'
        data.searchEndDate = this.searchYear.substring(0, 4) + '1231'
      }
      const toRouter = {
        name: route,
        params: {
          data: data,
        },
      }
      console.log('data', data)
      this.$EventBus.$emit('searchComp', { clntId: data.clntId, compId: data.compId }, 'dashBoard')
      this.$router.push(toRouter)
    },
  },
}
</script>
<style lang="scss" scoped>
.doc-card {
  border-radius: 8px;
  background-color: #fafafc;
  border: 1px solid transparent;
}
</style>
